import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import '../css/Inbox.css'
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { updateAlert } from '../redux/actions';
import { Avatar as MuiAvatar } from '@mui/material';
import Avatar, { genConfig } from 'react-nice-avatar';
import { stringAvatar } from '../../../utils/muiAvatar';
import getDate from '../../../utils/getDate';
import NoData from '../components/NoData';


function Inbox(props) {

  const { user, handleAlert } = props;
  const inboxTitles = ["@ me", "@ my projects", "@ my models", "My comments"]
  const routeMap = {
    0: "getReplyComments",
    1: "getCommentsToMyProjects",
    2: "getCommentsToMyModels",
    3: "getMyComments"
  }

  const acceptCookie = document.cookie.includes("acceptedCookiePolicy=true")
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [cookies] = useCookies([""]);
  const [comments, setComments] = useState([]);
  const [title, setTitle] = useState(acceptCookie && cookies["inboxTitle"] ? parseInt(cookies["inboxTitle"]) : 0);

  const avatarStyle = {
    width: "50px",
    height: "50px",
  }

  useEffect(() => {
    const route = routeMap[title];
    setComments([])
    axios({
      method: 'post',
      url: `/api/m2d/comments/${route}`,
      data: {
        uid: user.id
      }
    }).then((res) => {
      let newComments = []
      switch (title) {
        case 0:
          setComments(res.data)
          break;

        case 1:
          const projects = res.data
          for (const project of projects) {
            newComments = [newComments, ...project.m2dComments.map((comment) => {
              comment['m2dProject'] = {
                id: project.id,
                name: project.name
              };
              return comment;
            })];
          }
          setComments(newComments.slice(1));
          break;

        case 2:
          const models = res.data
          for (const model of models) {
            newComments = [newComments, ...model.m2dComments.map((comment) => {
              comment['m2dModel'] = {
                id: model.id,
                name: model.name
              };
              return comment;
            })];
          }
          setComments(newComments.slice(1));

          break;

        default:
          setComments(res.data);
          break;
      }

    }).catch((err) => {
      props.handleAlert("error", err.message, 3000);
      console.log(err);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, handleAlert, title])

  const handleCommentType = (i) => {
    setTitle(i);
  }

  const handleComment = (cid, mid, pid) => {
    console.log(cid, mid, pid);
    // TODO
  }

  return (
    <div className="page-content">
      <div className="inbox-layout">
        <div className="inbox-sidebar">
          {inboxTitles.map((inboxTitle, i) => {
            return (
              <div className={`inbox-index${title === i ? "-disabled" : ""}`} key={i} onClick={() => handleCommentType(i)}>
                {inboxTitle}
              </div>
            )
          })}
        </div>
        <div className="inbox-content">
          <div className="inbox-title">
            {inboxTitles[title]}
          </div>
          <div className="inbox-white-space"></div>
          <div className="inbox-messages">
            {comments.length > 0 ? comments.map((comment, j) => {
              return (
                <div className="inbox-comment-content" key={j} onClick={() => handleComment(comment.id, comment.m2dModel ? comment.m2dModel.id : null, comment.m2dProject ? comment.m2dProject.id : null)}>
                  <div className="inbox-comment-avatar">
                    {
                      comment.user.avatar ? (
                        <MuiAvatar key={comment.user.id} sx={avatarStyle}><Avatar style={{ width: '50px', height: '50px' }} {...genConfig(JSON.parse(comment.user.avatar))} /></MuiAvatar>
                      ) : (
                        <MuiAvatar {...stringAvatar(`${comment.user.firstName} ${comment.user.lastName}`, avatarStyle, true, true)} key={comment.user.id} />
                      )
                    }
                  </div>
                  <div className="inbox-comment-info">
                    <div className="inbox-comment-username">
                      {`@${comment.user.firstName} ${comment.user.lastName} ${title === 0 ? "replied to my comment:" : title === 3 ? "" : "commented on my"} ${title === 1 ? `project ${comment.m2dProject ? comment.m2dProject.name : ""}` : title === 2 ? `model ${comment.m2dModel ? comment.m2dModel.name : ""}` : ""}`}
                    </div>
                    <div className="inbox-comment-comment">
                      {comment.comment}
                    </div>
                    <div className="inbox-comment-datetime">
                      {getDate(comment.datetime)}
                    </div>
                  </div>
                </div>
              )
            }) : (
              <NoData info="No Comment" style={{ marginTop: "0px" }} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    sidebarOpen: parseInt(state.m2d.sidebarOpen),
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Inbox)
